/**
 * The marketing site and the app are two separate bundles served from the
 * same origin: index.html (LandingPage, PricingPage, PrivacyPolicyPage) and
 * app.html (everything under /app, /auth, /onboarding).
 * Cloudflare Pages routes between them via public/_redirects, and the Vite
 * dev and preview servers mirror that in vite.config.ts.
 *
 * Each bundle only knows its own routes, so moving between them has to be a
 * real document load. react-router's `navigate()` and `<Link>` are
 * client-side only: they would look for a route the current bundle does not
 * have and fall through to its 404 instead of loading the other entry.
 *
 * Use `hardNavigate` for imperative crossings and a plain `<a href>` for
 * declarative ones. Within a bundle, keep using `navigate()` and `<Link>`.
 */

/** Full document load, for navigating from one bundle to the other. */
export function hardNavigate(path: string): void {
  window.location.assign(path);
}
